import { render, staticRenderFns } from "./sectors-edit.vue?vue&type=template&id=7ddf9228&scoped=true&"
import script from "./sectors-edit.vue?vue&type=script&lang=js&"
export * from "./sectors-edit.vue?vue&type=script&lang=js&"
import style0 from "./sectors-edit.vue?vue&type=style&index=0&id=7ddf9228&prod&lang=scss&"
import style1 from "./sectors-edit.vue?vue&type=style&index=1&id=7ddf9228&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ddf9228",
  null
  
)

export default component.exports